import { SideBarItemData } from '@/components/ui/SideBarItem';
import { Routes } from '@/constants/routes';
import { NavigationBarItemType } from '@/components/ui/NavigationBar/types';

export const SideBarMaxLetterLength = 22;

export const SideBarIconLabels: Record<string, string> = {
  Checked: 'Aufgaben',
  AccountCircle: 'Kundendetails',
  Money: 'Förderungen',
  Planner: 'Analyse',
  TodoList: 'Herausforderungen',
  Idea: 'Konzept',
  Wallet: 'Unterlagenliste',
  Chart: 'Haushaltsrechner',
  Users: 'Mandanten',
  Home: 'Cockpit',
  Exit: 'Beenden',
  GoBack: 'Zurück',
  Section: 'Teams',
  Sort: 'Pipeline',
  Calendar: 'Meetings',
  BanknoteDouble: 'Meeting-Pools',
  Document: 'API-Schl\u00fcssel',
  Monitor: 'Benutzerverwaltung',
  Navigation: 'Telefonie',
  Diagram: 'Dashboard',
  Filter: 'Segmente',
};

// SA: Alles sichtbar
export const SideBarSANavigation: SideBarItemData[] = [
  {
    icon: 'Diagram',
    path: Routes.Dashboard,
  },
  {
    icon: 'Home',
    iconActive: 'HomeActive',
    path: Routes.Cockpit,
  },
  {
    icon: 'Monitor',
    path: Routes.UsersTeams,
    label: 'Benutzer & Teams',
  },
  {
    icon: 'Sort',
    path: Routes.Deals,
  },
  {
    icon: 'Calendar',
    path: Routes.Meetings,
  },
  // F9 (Entscheid Alex 16.10.2026): Kalender ins SA-Menue; SA und Unteradmin
  // sehen dort private Titel der VPs.
  {
    icon: 'Planner',
    path: Routes.Calendar,
    label: 'Kalender',
  },
  {
    icon: 'BanknoteDouble',
    path: Routes.MeetingPools,
  },
  {
    icon: 'Checked',
    path: Routes.Todos,
  },
  {
    icon: 'Users',
    iconActive: 'UsersActive',
    path: Routes.Customers,
  },
  {
    icon: 'Documents',
    path: Routes.ActivityLog,
    label: 'Aktivitaetslog',
  },
  {
    icon: 'Filter',
    path: Routes.Segments,
    label: 'Segmente',
  },
  {
    icon: 'Documents',
    path: Routes.MailTemplates,
    label: 'E-Mail-Templates',
  },
  // BER-67: die vier Bereiche der automatisierten Antragserstellung
  // (Antragstypen, Gesellschaften, Personenfelder, Antragsvorlagen) sind unter
  // einem Punkt mit Tabs zusammengefasst.
  {
    icon: 'Bill',
    path: Routes.ApplicationAdmin,
    label: 'Antragserstellung',
  },
  {
    icon: 'Idea',
    path: Routes.Neuigkeiten,
    label: 'Neuigkeiten',
  },
  // Prozessdoku (Read-only, docs/tasks/prozessdoku-admin-ui.md). Bewusst NUR
  // in der SA-Navigation — der Endpunkt haengt an `role:sa`.
  {
    icon: 'Documents',
    path: Routes.Prozesse,
    label: 'Prozesse',
  },
  // API-Schluessel (Decision #252, Scope H): am 13.04.2026 beim Design-Umbau
  // (6f07b5a9f) aus dem Menue gefallen, die Seite bestand weiter nur per URL.
  // Nur echte Rolle `sa` — die Seite leitet alle anderen um, die API haengt an
  // `can:users.create`.
  {
    icon: 'Document',
    path: Routes.ApiKeys,
    label: 'API-Schlüssel',
    nurEchterSA: true,
  },
];

// VV/VD: Dashboard, Teams, Pipeline, Meetings, Meeting-Pools, Reports
export const SideBarVVNavigation: SideBarItemData[] = [
  {
    icon: 'Diagram',
    path: Routes.Dashboard,
  },
  {
    icon: 'Home',
    iconActive: 'HomeActive',
    path: Routes.Cockpit,
  },
  {
    icon: 'Section',
    path: Routes.Teams,
  },
  {
    icon: 'Sort',
    path: Routes.Deals,
  },
  {
    icon: 'Calendar',
    path: Routes.Meetings,
  },
  {
    icon: 'BanknoteDouble',
    path: Routes.MeetingPools,
  },
  {
    icon: 'Checked',
    path: Routes.Todos,
  },
  {
    icon: 'Users',
    iconActive: 'UsersActive',
    path: Routes.Customers,
  },
  {
    icon: 'Idea',
    path: Routes.Neuigkeiten,
    label: 'Neuigkeiten',
  },
];

// VM: Dashboard, Teams (eigenes), Pipeline, Meetings, Meeting-Pools, Mandanten
export const SideBarVMNavigation: SideBarItemData[] = [
  {
    icon: 'Diagram',
    path: Routes.Dashboard,
  },
  {
    icon: 'Home',
    iconActive: 'HomeActive',
    path: Routes.Cockpit,
  },
  {
    icon: 'Section',
    path: Routes.Teams,
  },
  {
    icon: 'Sort',
    path: Routes.Deals,
  },
  {
    icon: 'Calendar',
    path: Routes.Meetings,
  },
  {
    icon: 'BanknoteDouble',
    path: Routes.MeetingPools,
  },
  {
    icon: 'Checked',
    path: Routes.Todos,
  },
  {
    icon: 'Users',
    iconActive: 'UsersActive',
    path: Routes.Customers,
  },
  {
    icon: 'Idea',
    path: Routes.Neuigkeiten,
    label: 'Neuigkeiten',
  },
];

// VP: Dashboard, Cockpit, Kalender, Pipeline, Meetings, Aufgaben
export const SideBarVPNavigation: SideBarItemData[] = [
  {
    icon: 'Diagram',
    path: Routes.Dashboard,
  },
  {
    icon: 'Home',
    iconActive: 'HomeActive',
    path: Routes.Cockpit,
  },
  {
    icon: 'Planner',
    path: Routes.Calendar,
    label: 'Kalender',
  },
  {
    icon: 'Sort',
    path: Routes.Deals,
  },
  {
    icon: 'Calendar',
    path: Routes.Meetings,
  },
  {
    icon: 'Checked',
    path: Routes.Todos,
  },
  {
    icon: 'Idea',
    path: Routes.Neuigkeiten,
    label: 'Neuigkeiten',
  },
];

// BO: Dashboard, Mandanten, Meetings, Dokumente
export const SideBarBONavigation: SideBarItemData[] = [
  {
    icon: 'Diagram',
    path: Routes.Dashboard,
  },
  {
    icon: 'Home',
    iconActive: 'HomeActive',
    path: Routes.Cockpit,
  },
  {
    icon: 'Calendar',
    path: Routes.Meetings,
  },
  {
    icon: 'Checked',
    path: Routes.Todos,
  },
  {
    icon: 'Users',
    iconActive: 'UsersActive',
    path: Routes.Customers,
  },
  {
    icon: 'Idea',
    path: Routes.Neuigkeiten,
    label: 'Neuigkeiten',
  },
];


// @todo(KAN-92):connect with paths
export const CustomerDetailsSideBar: SideBarItemData[] = [
  {
    icon: 'AccountCircle',
    path: Routes.CustomerDetails,
  },
  {
    icon: 'Money',
    path: Routes.Finance,
  },
  {
    icon: 'Planner',
    path: Routes.Planner,
  },
  {
    icon: 'TodoList',
    path: Routes.LifePlan,
  },
  {
    icon: 'Idea',
    path: Routes.Concept,
  },
  {
    icon: 'Wallet',
    path: Routes.Documents,
  },
  {
    icon: 'Chart',
    path: Routes.Household,
  },
];

export const LifePlanSideBar: NavigationBarItemType[] = [
  {
    label: 'Straße des Lebens DIN',
    icon: 'Map',
    activeIcon: 'MapActive',
    path: Routes.LifeRoad,
  },
  {
    label: 'Diagramm',
    icon: 'Diagram',
    activeIcon: 'DiagramActive',
    path: Routes.Diagram,
  },
  {
    label: 'Kindersparen',
    icon: 'ID',
    activeIcon: 'ID',
    path: Routes.Children,
  },
  {
    label: 'Hausgeld',
    icon: 'Bill',
    activeIcon: 'BillActive',
    path: Routes.HousePayment,
  },
  {
    label: '§10a EStG',
    icon: 'Euro',
    activeIcon: 'EuroActive',
    path: Routes.Estg,
  },
  {
    label: 'Altersvorsorge',
    icon: 'BanknoteDouble',
    activeIcon: 'BanknoteDoubleActive',
    path: Routes.RetirementClient,
  },
  {
    label: 'Früher schuldenfrei',
    icon: 'Bill',
    activeIcon: 'BillActive',
    path: Routes.DebtFreeCalculator,
  },
];

export const PlannerSideBarItems: NavigationBarItemType[] = [
  {
    label: 'Leben Bestand',
    activeIcon: 'HealthActive',
    icon: 'Health',
    path: Routes.LifeInsurance,
  },
  {
    label: 'Sparvergleich',
    activeIcon: 'BanknoteAlternativeActive',
    icon: 'BanknoteAlternative',
    path: Routes.Savings,
  },
  {
    label: 'Bausparvertrag',
    activeIcon: 'DocumentActive',
    icon: 'Document',
    path: Routes.BSC,
  },
  {
    label: 'KLV',
    activeIcon: 'MoneyBag',
    icon: 'MoneyBag',
    path: Routes.KLV,
  },
  {
    label: 'KK-Analyse',
    activeIcon: 'HealthActive',
    icon: 'Health',
    path: Routes.HealthInsuranceAnalysis,
  },
  {
    label: 'Vergleichsrechner',
    activeIcon: 'BanknoteDoubleActive',
    icon: 'BanknoteDouble',
    path: Routes.ComparisonCalculator,
  },
];

export const FinancesSideBarItems: NavigationBarItemType[] = [
  {
    label: 'Förderungen',
    icon: 'Finance',
    activeIcon: 'FinanceActive',
    path: Routes.Funding,
  },
  {
    label: 'Sach',
    icon: 'File',
    activeIcon: 'FileActive',
    path: Routes.FinanceInfo,
  },
];




export const getSubItemsForIcon = (
  icon: string,
): NavigationBarItemType[] => {
  switch (icon) {
    case 'Planner':
      return PlannerSideBarItems;
    case 'Money':
      return FinancesSideBarItems;
    case 'TodoList':
      return LifePlanSideBar;
    // Chart, Idea, Wallet haben nur einen Unterpunkt - keine Dropdown anzeigen
    default:
      return [];
  }
};

export const getParentRouteForIcon = (icon: string): string => {
  switch (icon) {
    case 'Planner':
      return Routes.Planner;
    case 'Money':
      return Routes.Finance;
    case 'TodoList':
      return Routes.LifePlan;
    case 'Chart':
      return Routes.Household;
    case 'Idea':
      return Routes.Concept;
    case 'Wallet':
      return Routes.Documents;
    default:
      return '';
  }
};
